import { render, staticRenderFns } from "./SelectSubjects.vue?vue&type=template&id=2c32f4fd&scoped=true&lang=true&"
import script from "./SelectSubjects.vue?vue&type=script&lang=js&"
export * from "./SelectSubjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c32f4fd",
  null
  
)

export default component.exports